/* eslint-disable no-unused-vars */
// src/ChatAndTimeline.js
import React, { useRef, useState, useEffect } from 'react'
import { MessageList, Input, Button } from 'react-chat-elements'
import 'react-chat-elements/dist/main.css'
import './ChatAndTimeline.css'
import { Avatar, Badge, Box, Chip, Grow, IconButton, Paper, Popover, Popper, styled } from '@mui/material'
import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent'
import { format, isToday, isYesterday } from 'date-fns'
import { MdDeleteOutline, MdOutlineEmojiEmotions, MdOutlineReply } from 'react-icons/md'
import { RiAttachment2 } from 'react-icons/ri'
import { IoCloseCircle, IoCloseSharp, IoCopyOutline, IoSend } from 'react-icons/io5'
import { cn } from '../../lib/utils'
import { IoMdSearch } from 'react-icons/io'
import { FaArrowRightLong } from 'react-icons/fa6'
import EmojiPicker from 'emoji-picker-react'
import { FaChevronDown } from 'react-icons/fa'
import { BsEmojiSmile } from 'react-icons/bs'
import { useChatTimelineStore } from 'src/Containers/Risk/Store/ChatTimelineStore'
import { useParams } from 'react-router'
import dayjs from 'dayjs'
import CircularProgress from '@mui/material/CircularProgress'

const ChatAndTimeline = () => {
    const params = useParams()

    const timelineLoader = useChatTimelineStore(state => state.timelineLoader)
    const getTimelineByRiskId = useChatTimelineStore(state => state.getTimelineByRiskId)
    const timelineData = useChatTimelineStore(state => state.timelineData)

    const [ timeLineInfos, setTimeLineInfos ] = useState({})
    useEffect(() => {
        getTimelineByRiskId(params?.riskId)
    }, [])

    useEffect(() => {
        if (Object.keys(timelineData).length > 0) {
            setTimeLineInfos(timeLineInfos)
        }
    }, [timelineData])

    const [ messages, setMessages ] = useState([
        {
            id: 1,
            avatar: 'https://pixlr.com/images/index/ai-image-generator-one.webp',
            alt: 'User 1',
            position: 'left',
            type: 'text',
            title: 'Kursat',
            text: 'Give me a message list example !',
            date: 'Thu Jun 12 2024 16:26:58 GMT+0530 (India Standard Time)',
            reactions: []
        },
        {
            id: 2,
            avatar: 'https://img.freepik.com/premium-photo/colorful-design-with-word-art-it_577115-6527.jpg',
            alt: 'User 1',
            position: 'left',
            type: 'text',
            title: 'Kursat',
            text: 'Example Reply',
            date: 'Thu Jun 13 2024 14:26:58 GMT+0530 (India Standard Time)',
            reactions: [{ name: 'You', emoji: '❤️' }, { name: 'You', emoji: '❤️' }, { name: 'You', emoji: '😈' }, { name: 'You', emoji: '😈' }, { name: 'You', emoji: '😈' }]
        },
        {
            id: 3,
            alt: 'User 1',
            position: 'right',
            type: 'text',
            title: 'You',
            text: "That's a Wrap.",
            date: new Date(),
            reactions: [{ name: 'You', emoji: '❤️' }, { name: 'You', emoji: '❤️' }, { name: 'You', emoji: '😈' }, { name: 'You', emoji: '😈' }, { name: 'You', emoji: '😈' }]
        }
    ])
    const messageListRef = useRef(null)
    const [ input, setInput ] = useState('')
    const [ replyTo, setReplyTo ] = useState(null)
    const [ hoverMessage, setHoverMessage ] = useState({})
    const [ expandMoreMsgOption, setexpandMoreMsgOption ] = useState(null)
    const [ expandReactionEmojiAnchor, setExpandReactionEmojiAnchor ] = useState(null)
    const [ emojiPopoverAnchor, setEmojiPopoverAnchor ] = useState(null)
    const todayLabel = messages?.some((msg) => isToday(new Date(msg.date)))

    const timeoutRef = useRef(null)

    const handleDeleteMessage = () => {
        setMessages(messages?.filter((filterData) => filterData?.id !== hoverMessage?.id))
    }

    const handleCloseEmojiPoppover = () => {
        setEmojiPopoverAnchor(null)
    }

    const handleOpenEmojiPoppover = (e) => {
        setEmojiPopoverAnchor(e.currentTarget)
    }

    const handleMouseEnter = (event, data) => {
        setHoverMessage(data)
        setexpandMoreMsgOption(event.currentTarget)
    }

    const handleMouseLeave = () => {
        setexpandMoreMsgOption(null)
    }

    const handleExpandReactionEmojiAnchor = (event) => {
        setExpandReactionEmojiAnchor(event.currentTarget)
    }

    const handleCloseReactionEmojiAnchor = () => {
        setExpandReactionEmojiAnchor(null)
    }

    const handleReactEmoji = (e) => {
        setMessages(messages?.map((dt) => {
            if (dt?.id === hoverMessage?.id) {
                if (dt?.reactions?.map((mapDt) => mapDt?.name)?.includes(e?.name)) {
                    return {
                        ...dt,
                        reactions: dt?.reactions?.map((data) => {
                            if (data?.name === e?.name) {
                                return { ...data, emoji: e?.emoji }
                            } else {
                                return data
                            }
                        })
                    }
                } else {
                    return { ...dt, reactions: [ ...dt.reactions, e ] }
                }
            } else {
                return dt
            }
        }))
        handleCloseReactionEmojiAnchor()
    }

    const handleSend = () => {
        if (input.trim()) {
            const newMessage = {
                id: messages.length + 1,
                position: 'right',
                type: 'text',
                text: input,
                date: new Date(),
                title: 'You',
                reactions: [],
                reply: replyTo
                    ? {
                        id: replyTo.id,
                        title: replyTo.title,
                        titleColor: 'hsl(var(--primary))',
                        message: replyTo.text
                    }
                    : null
            }
            setMessages([ ...messages, newMessage ])
            setInput('')
            setReplyTo(null)
            setTimeout(() => {
                if (messageListRef.current) {
                    messageListRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' })
                }
            }, 100)
        }
    }

    const handleReply = (message) => {
        setReplyTo(message)
    }

    const handleReplyedMsgClicked = (message) => {
        const repliedMessage = messages.find(msg => msg.id === message.reply.id)
        if (repliedMessage) {
            const highlightedMessage = document.getElementById(`message-${repliedMessage.id}`)
            if (highlightedMessage) {
                highlightedMessage.scrollIntoView({ behavior: 'smooth', block: 'center' })
                highlightedMessage.classList.add('highlight')
                setTimeout(() => {
                    highlightedMessage.classList.add('fade-out')
                    setTimeout(() => {
                        highlightedMessage.classList.remove('highlight', 'fade-out')
                    }, 500)
                }, 1500)
            }
        }
    }

    const ReplyBanner = () => {
        if (!replyTo) return null
        return (
            <div className='w-full flex flex-col justify-center items-center'>
                <div className="reply-banner">
                    <div className='w-[95%] p-[15px] rounded-[10px] bg-background'>
                        <p className='flex flex-row w-[100%]'><p className='text-muted font-bold'>Replying to: </p><p className='text-primary font-bold'>{replyTo.title}</p></p>
                        <p className='flex flex-row w-[100%]'><p className='text-muted font-bold'>messsage: </p><p className='text-primary font-bold break-words truncate ...'>{replyTo.text}</p></p>
                    </div>
                    <div className='w-[5%] mr-[-5px] flex flex-col justify-start items-center'>
                        <IconButton style={{ padding: '0px' }} onClick={() => setReplyTo(null)} >
                            <IoCloseCircle color='hsl(var(--primary))' />
                        </IconButton>
                    </div>
                </div>
            </div>
        )
    }
    const getDateLabel = (messages) => {
        const todayMessages = messages?.filter((msg) => isToday(new Date(msg.date)))
        const yesterdayMessages = messages?.filter((msg) => isYesterday(new Date(msg.date)))

        if (todayMessages.length > 0) {
            return 'Today'
        } else if (yesterdayMessages.length > 0) {
            return 'Yesterday'
        } else {
            const earliestMessageDate = new Date(Math.min(...messages.map(msg => new Date(msg.date))))
            return format(earliestMessageDate, 'MMM dd')
        }
    }

    const todayLabels = getDateLabel(messages)

    const handleMessageView = (useName, message) => {
        const messageSplit = message.split(' ')
        const userNameSplit = useName.split(' ')

        if (messageSplit[0].toLowerCase() === 'you') {
            return <p className='text-grey text-[12px] font-light'>
                <span className='font-bold text-shadow' >{messageSplit[0] } </span>
                {messageSplit.slice(1).join(' ')}
            </p>
        } else if (messageSplit.slice(0, 1).includes(useName.split(' ')[0])) {
            const filterdData = messageSplit.filter(word => !userNameSplit.includes(word))
            return <p className='text-grey text-[12px] font-light'>
                <span className='font-bold text-shadow' >{useName } </span>
                {filterdData.join(' ')}
            </p>
        }
    }
    return (
        <Box container spacing={{ md: 1 }} className='group-chat-container p-8 h-[100%]'>
            <Box className='w-full h-[100%] flex flex-row justify-between bg-card shadow shadow-shadow-500/40'>
                <Box className='flex flex-col justify-center items-start w-[50%] h-[100%]'>
                    {
                        timelineLoader
                            ? <CircularProgress style={{ color: 'hsl(var(--card))' }} />
                            : (
                                <Timeline sx={{
                                    [`& .${timelineOppositeContentClasses.root}`]: {
                                        flex: 0.7
                                    },
                                    height: '100%',
                                    overflow: 'auto',
                                    width: '100%'
                                }} >
                                    {
                                        Object.keys(timeLineInfos).length > 0
                                            ? (
                                                timeLineInfos?.Timeline.map((element, ind, arr) => {
                                                    return (
                                                        <>
                                                            <TimelineItem key={`${element.Event}-${ind}`} sx={{ minHeight: '20%', minWidth: '100%' }}>
                                                                <TimelineOppositeContent
                                                                    sx={{ m: 'auto 0', minWidth: '30%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
                                                                    align="right"
                                                                    variant="body2"
                                                                    color="text.secondary"
                                                                >
                                                                    {ind === 0 && <p className='mb-[5px] text-primary text-[12px] font-bold'>End</p>}
                                                                    <p className='text-grey text-[12px]'>{dayjs(element.Timestamp).format('MMM DD, YYYY')}</p>
                                                                    <p className='text-grey text-[12px]'>{dayjs(element.Timestamp).format('hh:mm A')}</p>
                                                                    {ind === arr.length - 1 && <p className='mt-[5px] text-primary text-[12px] font-bold'>Start</p>}
                                                                </TimelineOppositeContent>
                                                                <TimelineSeparator sx={{ minWidth: '10%' }}>
                                                                    <TimelineConnector sx={{ width: ind === 2 ? '5px' : '3px', background: ind === 2 ? 'hsl(var(--primary))' : 'hsl(var(--primary-foreground))' }} />
                                                                </TimelineSeparator>
                                                                <TimelineContent sx={{ minWidth: '60%', m: 'auto 0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }} >
                                                                    <p className='text-accent-foreground text-[12px] font-bold'>{element.Event}</p>
                                                                    <p>{handleMessageView(element.ModifiedBy, element.Message)}</p>
                                                                </TimelineContent>
                                                            </TimelineItem>
                                                        </>
                                                    )
                                                })
                                            )
                                            : (
                                                <p className='noDataCenter'>No changes to preview here.</p>
                                            )
                                    }

                                </Timeline>
                            )
                    }

                </Box>
                <Box className='w-[50%] h-[100%] p-3'>
                    <div className="chat-box">
                        <div className='flex flex-col justify-center items-center w-full'>
                            <div className='flex flex-row justify-between items-center p-2 border-2 bg-card rounded-[10px] border-border w-[90%]'>
                                <div className='flex flex-row items-center w-[60%]' >
                                    <p className='text-primary font-bold'>Risk : </p>
                                    <p className='text-muted font-bold pl-1'>Vacancy</p>
                                    <span className='text-muted font-light pl-2'>#1102</span>
                                    <Chip sx={{ color: 'hsl(var(--card))', background: 'hsl(var(--yellow))', marginLeft: '5px' }} label='medium' size="small" />
                                </div>
                                <div className='flex flex-row justify-end items-center w-[40%]' >
                                    <p className='text-primary font-bold'>Online :</p>
                                    <p className='text-muted font-bold pl-2'>2/10</p>
                                </div>
                            </div>
                        </div>
                        <div className='flex flex-col justify-center mt-3 items-center w-full'>
                            <div className='flex flex-row justify-between items-center bg-card focus:outline-none focus:ring focus:ring-violet-300 py-1 border-2 rounded-[50px] px-[10px] border-border w-[80%]'>
                                <IoMdSearch color='hsl(var(--primary))' style={{ width: '5%' }} /><input placeholder='Search' className='w-[95%] focus:outline-none focus:none text-primary' /><FaArrowRightLong color='hsl(var(--primary))' style={{ width: '5%' }} />
                            </div>
                        </div>
                        {todayLabel && (
                            <div className="flex justify-center mb-2 mt-2">
                                <div className='border-2 bg-card rounded-[20px] border-border w-[15%] text-center text-muted'>{todayLabels}</div>
                            </div>
                        )}
                        <MessageList
                            className='message-list'
                            lockable={true}
                            onReplyMessageClick={(e) => handleReplyedMsgClicked(e)}
                            toBottomHeight={'100%'}
                            dataSource={messages?.map((data) => {
                                const groupedData = data?.reactions?.reduce((reduceData, item) => {
                                    const existing = reduceData.find(entry => entry.emoji === item.emoji)

                                    if (existing) {
                                        existing.emojArr.push(item)
                                    } else {
                                        reduceData.push({
                                            emoji: item.emoji,
                                            emojArr: [item]
                                        })
                                    }

                                    return reduceData
                                }, [])

                                return {
                                    ...data,
                                    title: (
                                        <div className={cn('flex flex-row', data?.position === 'right' && 'justify-end')}>
                                            <p className={cn('text-muted font-bold', 'mr-4')}>{data?.title}</p>
                                            <p className='text-[12px] text-muted font-light'>{String(format(data?.date, 'hh:mm a'))}</p>
                                        </div>
                                    ),
                                    text: (
                                        <div >
                                            {data?.replyTo && (
                                                <div className="reply-to">
                                                    <span>Replying to: {data.replyTo.text}</span>
                                                </div>
                                            )}
                                            <div ref={messageListRef} id={`message-${data?.id}`} className={cn(data?.position === 'right' ? 'msg-right-text' : 'msg-left-text')} style={{ height: '100%' }}
                                                onMouseEnter={(e) => handleMouseEnter(e, data)}
                                                onMouseLeave={() => {
                                                    if (timeoutRef.current) {
                                                        clearTimeout(timeoutRef.current)
                                                    }

                                                    timeoutRef.current = setTimeout(() => {
                                                        handleMouseLeave()
                                                    }, 900)
                                                }}
                                            >
                                                {data?.text}
                                            </div>
                                            {data?.position === 'right'
                                                ? <div className={cn('w-[100%] flex flex-row justify-between')}>
                                                    <IconButton style={{ padding: '0px' }} onClick={() => handleReply(data)}>
                                                        <MdOutlineReply color='hsl(var(--primary))' />
                                                    </IconButton>
                                                    <span className={cn('flex flex-row justify-end')}>{groupedData?.map((dt, index) => <p key={index} className={cn('text-[12px] react-icon-box')}>{dt?.emojArr?.length}{dt?.emoji}</p>)}</span>
                                                </div>
                                                : <div className={cn('w-[100%] flex flex-row justify-between')}>
                                                    <span className={cn('flex flex-row justify-start')}>{groupedData?.map((dt, index) => <p key={index} className={cn('text-[12px] react-icon-box')}>{dt?.emojArr?.length}{dt?.emoji}</p>)}</span>
                                                    <IconButton style={{ padding: '0px' }} onClick={() => handleReply(data)}>
                                                        <MdOutlineReply color='hsl(var(--primary))' />
                                                    </IconButton>
                                                </div>}
                                        </div>
                                    )
                                }
                            })}
                        />
                        <ReplyBanner />
                        <div className="input-container">
                            <Input
                                placeholder="Type your message here / To mention add @"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => { if (e?.key === 'Enter') { handleSend(); handleCloseEmojiPoppover() } }}
                                rightButtons={
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }} >
                                        <RiAttachment2
                                            style={{ width: '22px', height: '22px' }}
                                            color="hsl(var(--border))"
                                            onClick={handleSend}
                                        />
                                        <MdOutlineEmojiEmotions
                                            style={{ width: '22px', height: '22px' }}
                                            color="hsl(var(--border))"
                                            onClick={(event) => {
                                                handleOpenEmojiPoppover(event)
                                            }}
                                        />
                                    </div>
                                }
                            />
                            <IconButton style={{ background: 'hsl(var(--primary))', width: '35px', height: '35px' }}
                                onClick={() => {
                                    handleSend()
                                    handleCloseEmojiPoppover()
                                }}
                            >
                                <IoSend color='hsl(var(--card))' style={{ width: '15px', height: '15px' }} />
                            </IconButton>
                        </div>
                    </div>
                    <Popper
                        open={Boolean(expandMoreMsgOption)}
                        anchorEl={expandMoreMsgOption}
                        placement={ hoverMessage?.position === 'left' ? 'top-end' : 'top-start' }
                        transition
                    >
                        {({ TransitionProps }) => (
                            <Grow {...TransitionProps} timeout={450}>
                                <Box sx={{ p: 0.5 }}>
                                    <div
                                        onMouseEnter={() => {
                                            setexpandMoreMsgOption((data) => data)
                                            if (timeoutRef.current) {
                                                clearTimeout(timeoutRef.current)
                                            }
                                        }}
                                        className='w-full h-full rounded-[20px] border-2 border-border bg-primary-foreground'
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <IconButton onClick={handleExpandReactionEmojiAnchor} >
                                            <FaChevronDown style={{ height: '16px', width: '16px' }} color='hsl(var(--primary))' />
                                        </IconButton>
                                        <IconButton onClick={handleExpandReactionEmojiAnchor} >
                                            <BsEmojiSmile style={{ height: '16px', width: '16px' }} color='hsl(var(--primary))' />
                                        </IconButton>
                                    </div>
                                </Box>
                            </Grow>
                        )}
                    </Popper>
                    <Popover
                        open={Boolean(expandReactionEmojiAnchor)}
                        anchorEl={expandReactionEmojiAnchor}
                        onClose={handleCloseReactionEmojiAnchor}
                        className="emoji-picker-container"
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: hoverMessage?.position === 'left' ? 'right' : 'left'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: hoverMessage?.position === 'left' ? 'left' : 'right'
                        }}
                        PaperProps={{
                            style: { borderRadius: '25px' }
                        }}
                    >
                        <EmojiPicker
                            reactionsDefaultOpen={true}
                            onEmojiClick={(e) => {
                                const addReactEmmojiData = { name: 'barath', emoji: e?.emoji }
                                handleReactEmoji(addReactEmmojiData)
                                handleMouseLeave()
                            }}
                            onReactionClick={(e) => {
                                const addReactEmmojiData = { name: 'barath', emoji: e?.emoji }
                                handleReactEmoji(addReactEmmojiData)
                                handleMouseLeave()
                            }}
                        />
                        <div className='p-[10px]'>
                            <p onClick={() => {
                                handleReply(hoverMessage)
                                handleCloseReactionEmojiAnchor()
                                handleMouseLeave()
                            }} className='py-[5px] px-[10px] cursor-pointer hover:bg-primary-foreground hover:rounded-[20px] flex flex-row items-center font-bold text-muted'><MdOutlineReply /><p className='pl-[15px] font-bold text-muted' >Reply</p></p>
                            <p className='py-[5px] px-[10px] cursor-pointer hover:bg-primary-foreground hover:rounded-[20px] flex flex-row items-center font-bold text-muted'><MdDeleteOutline /><p className='pl-[15px] font-bold text-muted' >Copy</p></p>
                            <p onClick={() => {
                                handleDeleteMessage()
                                handleCloseReactionEmojiAnchor()
                                handleMouseLeave()
                            }} className='py-[5px] px-[10px] cursor-pointer hover:bg-primary-foreground hover:rounded-[20px] flex flex-row items-center font-bold text-muted'><IoCopyOutline /><p className='pl-[15px] font-bold text-muted' >Delete</p></p>
                        </div>
                    </Popover>
                    <Popover
                        open={Boolean(emojiPopoverAnchor)}
                        anchorEl={emojiPopoverAnchor}
                        onClose={handleCloseEmojiPoppover}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right'
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right'
                        }}
                    >
                        <EmojiPicker
                            allowExpandReactions={true}
                            onEmojiClick={(e) => {
                                setInput(input + e.emoji)
                            }}
                            onReactionClick={(e) => {
                                setInput(input + e.emoji)
                            }}
                        />
                    </Popover>
                </Box>
            </Box>
        </Box>
    )
}

export default ChatAndTimeline
